import { render, staticRenderFns } from "./EwcGroupTable.vue?vue&type=template&id=1d79b979&scoped=true&"
import script from "./EwcGroupTable.vue?vue&type=script&lang=js&"
export * from "./EwcGroupTable.vue?vue&type=script&lang=js&"
import style0 from "./EwcGroupTable.vue?vue&type=style&index=0&id=1d79b979&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d79b979",
  null
  
)

export default component.exports